import * as React from 'react';

import { useSetAtom } from 'jotai';

import { $populateCameraFormAction } from '../_state/cameraForm.state';
import { CameraDetailRecord } from '../types/sidecar';

type Props = {
  camera: CameraDetailRecord | null | undefined;
};

export const usePopulateCameraForm = ({ camera }: Props) => {
  const populateForm = useSetAtom($populateCameraFormAction);

  React.useEffect(() => {
    populateForm(camera);
  }, [camera, populateForm]);
};
